export default {
  // margin: 'auto',
  boxSizing: 'border-box',
  animation: '$plane 1s linear infinite',
  background: '#197AFA',
};
